"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var base = function base(_ref) {
  var theme = _ref.theme,
      inline = _ref.inline,
      center = _ref.center;
  return {
    display: inline ? 'inline-block' : theme.display,
    width: inline || center ? 'auto' : '100%',
    position: center ? 'absolute' : theme.position,
    padding: inline ? 0 : theme.padding,
    textAlign: theme.textAlign,
    boxSizing: theme.boxSizing,
    margin: theme.margin,
    top: center ? '50%' : theme.top,
    left: center ? '50%' : theme.left,
    transform: center ? 'translate(-50%, -50%)' : theme.transform
  };
};

var Root = _styledComponents["default"].div(_templateObject(), function (props) {
  return base(props);
});

var _default = Root;
exports["default"] = _default;